import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M794.41 213.59c32.555 0 58.923 26.367 58.923 58.88v461.653c0 32.597-26.368 58.965-58.922 58.965H229.547a58.923 58.923 0 01-58.88-58.923V272.512c0-32.555 26.368-58.923 58.922-58.923zm-101.546 252.5l-201.6 219.947a19.627 19.627 0 01-28.032.939l-104.235-99.84-148.48 144.085-.554.47v2.474c0 10.838 8.789 19.627 19.626 19.627h564.864a19.627 19.627 0 0019.627-19.627V598.187L692.907 466.09zm101.547-213.247H229.547a19.627 19.627 0 00-19.627 19.626v404.438l135.552-131.2a19.627 19.627 0 0127.264 0l103.125 99.072 202.496-221.014a19.627 19.627 0 0128.971 0L813.995 540.16V272.512a19.627 19.627 0 00-19.627-19.627zm-440.406 51.584a68.779 68.779 0 110 137.514 68.779 68.779 0 010-137.514zm0 39.253a29.44 29.44 0 100 58.965 29.44 29.44 0 000-58.922z"
});

function SvgPic(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pic_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'PicOutlined';

export default KuFoxIcons;
